export const VALIDATION_MSG = {
  required: 'Field is required.',
  accountExists: 'Account number already exists.',
  meterExists: 'Meter name already exists.',
  invalidDate: 'Please enter a valid date.',
  invalidStartDate: 'Start date must be equal to or before end date.',
  invalidEndDate: 'End date must be equal to or after start date.',
  invalidZipCode:
    'Zip code must have a valid format (ex: 12345 or 12345 6789).',
  invalidPostalCode: 'Postal code must have a valid format (ex: A1A 1A1).',
  invalidEmail: 'Email must have a valid format (ex: user@nimble-energy.com).',
  invalidPhoneNumber: 'Phone number must be a (XXX) XXX-XXXX format.',
};
